import React from 'react';
import Icon from './avatarGroup.png';
import s from './s.module.less';

const AvatarGroup = () => {
    return (
        <div className={s.wrap}>
            <img src={Icon} />
        </div>
    );
};

export default AvatarGroup;
